import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getPerformance } from 'firebase/performance';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

const hostname = window.location.hostname;
const isProduction = hostname === 'collect.runport.run';
const isDev = hostname === 'dev-collect.runport.run';
const isLocalhost = hostname === 'localhost';

// ============================================
// 既存プロジェクト（dot99）- ソーシャルログイン用
// ============================================
const existingConfig = isProduction
  ? {
      apiKey: 'AIzaSyCoarf7vU6-vft-DTV4kgCa3WSg82kb-1c',
      authDomain: 'collect.runport.run',
      projectId: 'dot99-prod',
      storageBucket: 'dot99-prod.appspot.com',
      messagingSenderId: '281512048896',
      appId: '1:281512048896:web:920cde0fd6849dce909be5',
    }
  : {
      apiKey: 'AIzaSyCi7l6aVfynjTyA9DpaguIdTLGeQFhpGpY',
      authDomain: isLocalhost ? 'localhost' : isDev ? 'dev-collect.runport.run' : 'dot99-dev.firebaseapp.com',
      projectId: 'dot99-dev',
      storageBucket: 'dot99-dev.appspot.com',
      messagingSenderId: '1065437798827',
      appId: '1:1065437798827:web:715fdb85b3fb4289acf2ee',
    };

// ============================================
// 新プロジェクト（myrunwallet）- メインアプリ用
// ============================================
const newConfig = isProduction
  ? {
      apiKey: 'AIzaSyCjKNyDV_CnBzaf23GuwTur0hxfsvCyZZI',
      authDomain: 'myrunwallet-prod.firebaseapp.com',
      projectId: 'myrunwallet-prod',
      storageBucket: 'myrunwallet-prod.firebasestorage.app',
      messagingSenderId: '343111622882',
      appId: '1:343111622882:web:c37dbae69b2aa893cf7ebb',
      measurementId: 'G-YJMWEETRHE',
    }
  : {
      apiKey: 'AIzaSyBsqDURmWimQuXq8clXJhF2AV2oSdGnhZ8',
      authDomain: 'myrunwallet-dev.firebaseapp.com',
      projectId: 'myrunwallet-dev',
      storageBucket: 'myrunwallet-dev.firebasestorage.app',
      messagingSenderId: '292376818323',
      appId: '1:292376818323:web:9548fcf5c462a7dae69366',
      measurementId: 'G-JZDW6Z3R7H',
    };

// ============================================
// reCAPTCHA v3 サイトキー（AppCheck用）
// ============================================
const recaptchaSiteKey = isProduction
  ? '6LfBJmssAAAAAB9CD9R4wE8yK1arTXQXX9JVwJgQ'
  : '6LfIM2ssAAAAADRdrxynBL9ffpGzYg_5zReAoJuE';

// ============================================
// アプリ初期化
// ============================================

/** 既存プロジェクト（ソーシャルログイン用） */
export const existingApp = initializeApp(existingConfig, 'existing');

/** 新プロジェクト（メインアプリ用） */
export const app = initializeApp(newConfig);

// ============================================
// AppCheck 初期化（myrunwallet のみ）
// ============================================
if (isLocalhost) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

if (recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

// ============================================
// サービスインスタンス
// ============================================

/** 既存プロジェクトのAuth（ソーシャルログイン用） */
export const existingAuth = getAuth(existingApp);

/** 既存プロジェクトのFirestore（usersコレクション参照用） */
export const existingDb = getFirestore(existingApp);

/** 新プロジェクトのAuth（カスタムトークン認証用） */
export const auth = getAuth(app);

/** 新プロジェクトのFirestore（メインDB） */
export const db = getFirestore(app);

/** 新プロジェクトのStorage */
export const storage = getStorage(app);

/** 既存プロジェクトのStorage（プロフィール画像参照用） */
export const existingStorage = getStorage(existingApp);

/** 新プロジェクトのFunctions */
export const functions = getFunctions(app, 'asia-northeast1');

// ============================================
// Analytics & Performance（本番・開発環境のみ）
// ============================================
export let analytics = null;
export let performance = null;

if (!isLocalhost) {
  analytics = getAnalytics(app);
  performance = getPerformance(app);
}

// ============================================
// エミュレーター接続（localhost のみ）
// ============================================
if (isLocalhost) {
  connectAuthEmulator(existingAuth, 'http://localhost:9099', { disableWarnings: true });
  connectAuthEmulator(auth, 'http://localhost:9098', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
